import React from "react";
import { GroupedColumn } from "@ant-design/charts";
import "./style.scss";

const AvgOfFacingsByRetailerChart = (props) => {
  const data = [...props.facingData].reverse();
  const data_sa = [
    {
      month: "January",
      avgFacingCount: 0,
    },
    {
      month: "February",
      avgFacingCount: 0,
    },
    {
      month: "March",
      avgFacingCount: 0,
    },
    {
      month: "April",
      avgFacingCount: 0,
    },
    {
      month: "May",
      avgFacingCount: 0,
    },
    {
      month: "June",
      avgFacingCount: 0,
    },
    {
      month: "July",
      avgFacingCount: 0,
    },
    {
      month: "August",
      avgFacingCount: 0,
    },
    {
      month: "September",
      avgFacingCount: 0,
    },
    {
      month: "October",
      avgFacingCount: 0,
    },
    {
      month: "November",
      avgFacingCount: 0,
    },
    {
      month: "December",
      avgFacingCount: 0,
    },
  ];

  const config_sa = {
    title: {
      visible: false,
      text: "No. of facing",
    },
    forceFit: true,
    data: data.length > 0 ? data : data_sa,
    xField: "month",
    yField: "avgFacingCount",
    label: { visible: false },
    groupField: "name",
    //color: ["#4A5DE8", "#A4AEF3", "#CDD2FB", "#4F5058"],
    color: [
      "#2b9ddb",
      "#7cfac3",
      "#00ab84",
      "#394856",
      "#e57364",
      "#4e79a7",
      "#59a14f",
      "#9c755f",
      "#f28e2b",
      "#edc948",
      "#bab0ac",
      "#e15759",
      "#b07aa1",
      "#76b7b2",
      "#ff9da7",
      "#2b9ddb",
      "#7cfac3",
      "#00ab84",
      "#394856",
      "#e57364",
      "#4e79a7",
      "#59a14f",
      "#9c755f",
      "#f28e2b",
      "#edc948",
      "#bab0ac",
      "#e15759",
      "#b07aa1",
      "#76b7b2",
      "#ff9da7",
      "#2b9ddb",
      "#7cfac3",
      "#00ab84",
      "#394856",
      "#e57364",
      "#4e79a7",
      "#59a14f",
      "#9c755f",
      "#f28e2b",
      "#edc948",
      "#bab0ac",
      "#e15759",
      "#b07aa1",
      "#76b7b2",
      "#ff9da7",
      "#2b9ddb",
      "#7cfac3",
      "#00ab84",
      "#394856",
      "#e57364",
      "#4e79a7",
      "#59a14f",
      "#9c755f",
      "#f28e2b",
      "#edc948",
      "#bab0ac",
      "#e15759",
      "#b07aa1",
      "#76b7b2",
      "#ff9da7",
      "#2b9ddb",
      "#7cfac3",
      "#00ab84",
      "#394856",
      "#e57364",
      "#4e79a7",
      "#59a14f",
      "#9c755f",
      "#f28e2b",
      "#edc948",
      "#bab0ac",
      "#e15759",
      "#b07aa1",
      "#76b7b2",
      "#ff9da7",
    ],
    yAxis: {
      title: {
        text: "No. of facings",
        visible: true,
        style: {
          fill: "#4A5DE8",
          fontSize: 13,
          fontWeight: "bold",
        },
      },
      min: 0,
    },
    xAxis: {
      title: {
        text: "Month",
        visible: true,
        style: {
          fill: "#4A5DE8",
          fontSize: 13,
          fontWeight: "bold",
        },
      },
      label: {
        style: {
          fill: "#000",
          fontSize: 14,
          fontWeight: "bold",
        },
      },
    },
  };

  return (
    <div className="Completed-Store-Audits-Chart-wp">
      
      <div className="separate-line" />
      <GroupedColumn {...config_sa} />
    </div>
  );
};

export default AvgOfFacingsByRetailerChart;
